import clsx from 'clsx';
import PropTypes from 'prop-types';

import { COOKING_FREQUENCY, HOUSEHOLD_SIZE } from 'constants/signup';
import { CardInput } from 'honeydew/CardInput';

export function EditHouseholdMealsForm({
    cookingFrequency,
    editable,
    handleCookingFrequencyChange,
    handleHouseholdSizeChange,
    householdSize,
}) {
    return (
        <div>
            <p className="mb-10 font-grotesk-bold">How many people are you shopping for including yourself?</p>
            <div className="grid grid-cols-5">
                {HOUSEHOLD_SIZE.map((inputAttributes) => {
                    const firstOption = inputAttributes.value === HOUSEHOLD_SIZE[0].value;
                    const lastOption = inputAttributes.value === HOUSEHOLD_SIZE[HOUSEHOLD_SIZE.length - 1].value;
                    const selectedOption = householdSize === inputAttributes.value;

                    return editable ? (
                        <CardInput
                            inputAttributes={{
                                ...inputAttributes,
                                name: 'household-size',
                                handleChange: handleHouseholdSizeChange,
                            }}
                            checked={householdSize === inputAttributes.value}
                            key={inputAttributes.value}
                            extendedStyles={{
                                wrapper: clsx('rounded-none shadow-transparent -ml-[1px]', {
                                    'rounded-l-md': firstOption,
                                    'rounded-r-md': lastOption,
                                    'border !border-kale bg-lime !if:border-beet z-10': selectedOption,
                                }),
                            }}
                        >
                            <p className="text-center text-body-mobile-sm">{inputAttributes.value}</p>
                        </CardInput>
                    ) : (
                        <div
                            key={inputAttributes.value}
                            className={clsx('-ml-[1px] border border-grey-light p-5', {
                                'rounded-l-md': firstOption,
                                'rounded-r-md': lastOption,
                                'z-10 border-kale bg-lime if:border-beet if:bg-strawberry': selectedOption,
                            })}
                        >
                            <p className="text-center text-body-mobile-sm">{inputAttributes.value}</p>
                        </div>
                    );
                })}
            </div>

            <p className="mb-10 mt-20 font-grotesk-bold">How many times do you usually cook each week?</p>

            <div className="mb-10 grid grid-cols-3">
                {COOKING_FREQUENCY.map((options) => {
                    const { shortLabel, ...inputAttributes } = options;

                    const firstOption = inputAttributes.value === COOKING_FREQUENCY[0].value;
                    const lastOption = inputAttributes.value === COOKING_FREQUENCY[COOKING_FREQUENCY.length - 1].value;
                    const selectedOption = cookingFrequency === inputAttributes.value;

                    return editable ? (
                        <CardInput
                            inputAttributes={{
                                ...inputAttributes,
                                name: 'cooking-frequency',
                                handleChange: handleCookingFrequencyChange,
                            }}
                            checked={cookingFrequency === inputAttributes.value}
                            key={inputAttributes.value}
                            extendedStyles={{
                                wrapper: clsx('rounded-none focus-within:outline-none shadow-transparent -ml-[1px]', {
                                    'rounded-l-md': firstOption,
                                    'rounded-r-md': lastOption,
                                    'border !border-kale z-10': selectedOption,
                                }),
                            }}
                        >
                            <p className="text-body-sm text-center">{shortLabel}</p>
                        </CardInput>
                    ) : (
                        <div
                            key={shortLabel}
                            className={clsx('-ml-[1px] border border-grey-light p-5', {
                                'rounded-l-md': firstOption,
                                'rounded-r-md': lastOption,
                                'z-10 border-kale bg-lime if:border-beet if:bg-strawberry': selectedOption,
                            })}
                        >
                            <p className="text-center text-body-mobile-sm">{shortLabel}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

EditHouseholdMealsForm.propTypes = {
    cookingFrequency: PropTypes.number.isRequired,
    editable: PropTypes.bool,
    handleCookingFrequencyChange: PropTypes.func.isRequired,
    handleHouseholdSizeChange: PropTypes.func.isRequired,
    householdSize: PropTypes.string.isRequired,
};

EditHouseholdMealsForm.defaultProps = {
    editable: false,
};
